<template>
  <div id="schedule-collection-container">
    <PreLoader class="preloader" />
    <div>
      <section>
        <div class="title-box is-orange">
          <h1 class="title">Regras de Coleta</h1>
        </div>
        <h3 class="text text-title">
          A WHIRLPOOL S.A. e seus respectivos transportadores não realizarão
          a(s) coleta(s) de Peças e/ou Volumes nos seguintes casos:
        </h3>
        <ul>
          <li>
            <p>
              Sem a embalagem original da peça ou outra adequada ao processo de
              transporte em bom estado, devidamente lacrada e identificada;
            </p>
          </li>
          <li>
            <p>
              Itens não contemplados na Ordem Inversa e/ou Carta de Coleta do
              transportador;
            </p>
          </li>
          <li>
            <p>
              Volumes ou Peças sem identificação do cliente e número da ordem
              inversa e número da Nota Fiscal de Devolução; conforme ANEXOS C e
              D.
            </p>
          </li>
        </ul>
        <p class="text text-title">
          O prazo para coleta irá variar conforme a região onde está situado o
          cliente e dos contratos vigentes entre a WHIRLPOOL S.A. e seus
          transportadores.
        </p>
        <p class="text">
          A não realização da coleta pelos motivos acima descritos ou pela
          indisponibilidade do cliente (não atender o transportador, não possuir
          a NF devolução ou as peças) assegura à WHIRLPOOL S.A. o direito de
          cancelar Ordem Inversa e cobrar o ressarcimento das despesas com
          transporte, caso trate de um caso de FG (fora de garantia).
        </p>
        <p class="text">
          Caso a transportadora não espere a conferência, informar o atendimento
          logístico, através do e-mail
          <span class="text-email"
            >atendimento_logistico_pecas@whirlpool.com</span
          >.
        </p>
      </section>
      <section>
        <div
          class="title-box"
          :class="[isPendingGatheringVisible ? 'is-orange' : 'is-grey']"
        >
          <h1 class="title" @click="togglePendingGatheringVisibility()">
            Agenda de Coleta para Aprovação
          </h1>
        </div>
        <div v-show="isDisplayingMessage()">
          <h3>Nenhuma data de coleta para aprovação.</h3>
        </div>
        <div class="sucess-alert" v-show="isShowingAlert">
          <span>Número da solicitação: {{ alertSolicitationNumber }}</span>
          <span
            >Data prevista de coleta {{ scheduleApprovalStatus }} com
            sucesso</span
          >
          <span v-if="scheduleApprovalStatus == 'recusada'"
            >Aguarde novo agendamento</span
          >
          <button @click="hideAlert">&#10005;</button>
        </div>
        <PendingGathering
          v-show="isPendingGatheringVisible"
          v-for="order in collectionsFilter(false)"
          :key="order.id"
          :inverseOrder="order.inverseOrder"
          :solicitationId="order.solicitationId"
          :scheduleDate="order.scheduleDate"
          @refusedSolicitation="updateSolicitationStatus(order)"
          @approvedSolicitation="approveSolicitationDate(order)"
        />
      </section>
      <section>
        <div
          class="title-box"
          :class="[isScheduledGatheringVisible ? 'is-orange' : 'is-grey']"
        >
          <h1 class="title" @click="toggleScheduledGatheringVisibility()">
            Coletas Agendadas
          </h1>
        </div>
        <div
          v-show="
            !collectionsFilter(true).length && isScheduledGatheringVisible
          "
        >
          <h3>Não existem coletas agendadas</h3>
        </div>
        <ScheduledGathering
          v-show="isScheduledGatheringVisible"
          v-for="order in collectionsFilter(true)"
          :key="order.id"
          :order="order"
        />
      </section>
    </div>
  </div>
</template>

<script>
import store from "@/store";
import PendingGathering from "@/components/home/schedule-collection/PendingGathering.vue";
import ScheduledGathering from "@/components/home/schedule-collection/ScheduledGathering.vue";
import CollectionsService from "@/services/schedule-collection/collections-service.js";
import PreLoader from "@/components/home/PreLoader";
import { EventBus } from "@/eventHub";

export default {
  name: "ScheduleCollection",
  components: {
    PendingGathering,
    ScheduledGathering,
    PreLoader
  },
  data: function() {
    return {
      isPendingGatheringVisible: true,
      isScheduledGatheringVisible: true,
      scheduledList: [],
      pendingList: [],
      collectionsList: [],
      isShowingAlert: false,
      alertSolicitationNumber: null,
      scheduleApprovalStatus: "recusada",
      status: ""
    };
  },
  methods: {
    isDisplayingMessage() {
      return (
        !this.collectionsFilter(false).length &&
        this.isPendingGatheringVisible &&
        this.status == "component mounted"
      );
    },
    togglePendingGatheringVisibility() {
      this.isPendingGatheringVisible = !this.isPendingGatheringVisible;
    },
    toggleScheduledGatheringVisibility() {
      this.isScheduledGatheringVisible = !this.isScheduledGatheringVisible;
    },
    calculateDaysDifference(actualDate, emailDate) {
      const difference = actualDate.getTime() - emailDate.getTime();
      return difference / (1000 * 60 * 60 * 24);
    },
    collectionsFilter(status) {
      const self = this;
      return this.collectionsList.filter(item => {
        const date = item.emailDate.split("/");
        const emailDate = new Date(
          parseInt(date[2]),
          parseInt(date[1]) - 1,
          parseInt(date[0])
        );
        const actualDate = new Date();
        if (
          item.scheduleApproval === 1 ||
          self.calculateDaysDifference(actualDate, emailDate) < -2
        ) {
          return status;
        } else {
          return !status;
        }
      });
    },
    hideAlert() {
      this.isShowingAlert = false;
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth"
      });
    },
    refreshPage(res, order) {
      this.alertSolicitationNumber = order.solicitationId;
      this.scheduleApprovalStatus = "recusada";
      this.isShowingAlert = true;
      this.collectionsList = [];
      this.getInverseOrders("component refreshed");
    },
    updateSolicitationStatus(order) {
      this.scrollToTop();
      const self = this;
      CollectionsService.cancelCollectionDate({
        cancel: true,
        inverseOrder: order.inverseOrder,
        items: order.items
      })
        .then(res => {
          self.refreshPage(res, order);
        })
        .catch(error => {
          console.log(error);
        });
    },
    reloadPage(res, order) {
      this.alertSolicitationNumber = order.solicitationId;
      this.scheduleApprovalStatus = "aprovada";
      this.isShowingAlert = true;
      this.collectionsList = [];
      this.getInverseOrders("component refreshed");
    },
    approveSolicitationDate(order) {
      this.scrollToTop();
      let self = this;
      CollectionsService.approveCollectionDate(order.inverseOrder)
        .then(res => {
          self.reloadPage(res, order);
        })
        .catch(error => {
          console.log(error);
        });
    },
    parseDate(collectionDate) {
      const date = collectionDate.split("/");
      const scheduleDate = new Date(
        parseInt(date[2]),
        parseInt(date[1]) - 1,
        parseInt(date[0])
      );
      return scheduleDate;
    },
    hasPastSevenDays(collectionDate) {
      const scheduleDate = this.parseDate(collectionDate);
      const actualDate = new Date();
      return this.calculateDaysDifference(actualDate, scheduleDate) > 7;
    },
    getValidInverseOrders(orders) {
      const self = this;
      return orders.filter(
        inverseOrder =>
          inverseOrder.cancelled !== 1 &&
          !self.hasPastSevenDays(inverseOrder.scheduleDate) &&
          inverseOrder.emailDate &&
          inverseOrder.scheduleDate != "Sem coleta"
      );
    },
    assignResponseToInverseOrders(response) {
      const self = this;
      this.collectionsList = this.getValidInverseOrders(response.data);
      this.status = status;
      EventBus.$emit("hidePreLoader");
    },
    getInverseOrders(status) {
      const self = this;
      CollectionsService.getAllInverseOrders(store.state.customer.sapcode)
        .then(response => {
          self.assignResponseToInverseOrders(response);
        })
        .catch(error => {
          console.log(error);
          EventBus.$emit("hidePreLoader");
        });
    }
  },
  mounted() {
    EventBus.$emit("showPreLoader");
    this.getInverseOrders("component mounted");
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/_colors.scss";

#schedule-collection-container {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  position: relative;
  min-height: 400px;
  width: 100%;

  .preloader {
    position: absolute;
    left: 75%;
    top: 90%;
  }

  div {
    width: 53.75%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: flex-start;

    section {
      width: 100%;

      .title-box {
        border-left: 4px solid $grey2;
        border-bottom: 1px solid $grey4;
        padding: 0 0 2px 5px;
        margin-top: 30px;

        .title {
          margin: 0;
          font-weight: 500;
          cursor: pointer;
        }

        &:hover {
          border-left-color: $orange1;
        }
      }

      .is-orange {
        border-left-color: $orange1;
      }

      .is-grey {
        // border-left-color: $grey2;
        background-color: #9e9e9e;
      }

      .text {
        text-align: left;
        padding-left: 10px;

        .text-email {
          color: $orange1;
          text-decoration: underline;
        }
      }

      .sucess-alert {
        color: $orange1;
        width: 650px;
        margin-top: 10px;
        height: 37px;
        line-height: 40px;
        font-size: 17px;
        text-align: center;
        margin: 40px 0 40px 10px;
        display: flex;
        flex-direction: column;

        span {
          height: 23px;
        }

        button {
          background: none;
          outline: none;
          border: none;
          color: $white;
          font-weight: bolder;
          font-size: 22px;

          &:hover {
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>
